const zh = {

    efficiency: {
        item1: "一站式服务",
        item2: "快速处理",
        item3: "7x24小时 客户支持"
    },

    menu: {
        solution: '解决方案',
        solution1: '全球跨境收单',
        solution2: '商户账户管理平台',
        solution3: '全球跨境付款',
        solution4: '多场景接入',
        aboutus: '关于我们',
        privacypolicy: '隐私政策',
        technicalaccess: '技术接入',
        technicalaccess1: '收单文档',
        technicalaccess2: '付款文档',
        technicalaccess3: '订阅文档',
        technicalaccess4: '常见问题',

        pricinginformation: '定价信息',
        contactus: '联系我们',
        contactusmessage: '联系我们获取免费账号',
        companyintroduction: '公司介绍',
        knowlegeHub: '知识中心',
        termofUse: '使用条款',
        companyMoments: '公司动态'

    },
    globalCollection: '全球跨境收单',
    solutions: {
        title1: '交易无国界',
        content1: '一站式接入Unionwallex收单，轻松获取全球支付能力',

        title2: '轻松对接本地支付，为您增加更多收益',

        cardtitle1: '\n' +
            '覆盖100+国家和地区，10+语言，10+币种',
        cardcontent1: 'Unionwallex在新兴市场拥有高渗透率，为您的用户提供更本地化的支付服务。',

        cardtitle2: '\n' +
            '支持全球530+主流支付方式',
        cardcontent2: '覆盖当地最主流的支付方式，如信用卡、电子钱包、线下网点、电信运营商等，一次解决多市场多渠道难题。',

        cardtitle3: '\n' +
            '提供多维的交易数据',
        cardcontent3: '提供实时订单查询 、退款、数据概览等功能，帮助您更好地理解用户交易行为，有效解决客诉受理难题。',

        cardtitle4: '\n' +
            '拥有灵活的资金管理策略',
        cardcontent4: '提供多种结算周期和结算方案，实现资金灵活调配，解决资金周转难题。',

    },
    globalcrossborderpay: {
        title1: '轻轻松松跨境付款',
        content1: '支持向您用户或合作伙伴的本地账户付款',

        title2: '为您提供批量、快速、便捷的付款服务',
        cardtitle1: '\n' +
            '本地流行的付款方式',
        cardcontent1: '甄选当地用户常用收款方式，如电子钱包、银行账户等。',

        cardtitle2: '\n' +
            '更低成本，更快到账',
        cardcontent2: '支持平台自助付款，无需开发接入即可使用，批量操作，极速到账。',

        cardtitle3: '\n' +
            '\n' +
            '高成功率的小额批量付款',
        cardcontent3: '支持受理小金额、高并发的付款请求，付款成功率可高达98%。',

        cardtitle4: '\n' +
            '灵活贴心的增值服务',
        cardcontent4: '您可自定义每一笔资金的审批流程，保证资金流向安全可控。同时提供账号收集功能，一步收集用户账户信息，简化付款步骤。',

        title3: '支持不同对接方案，最小化人力成本',
        cardtitl5: '场景1:免集成，开户可用',
        cardcontent5: '无需开发，通过商户后台即可批量付款给您的伙伴，提高您的工作效率。',

        cardtitl6: '场景2:API接入，1天即可完成接入',
        cardcontent6: 'API接入后，可通过您的应用、后台直接触发付款操作，减少运营人力投入。',


        title4: 'Unionwallex支持多国家本地付款方案',
        HongKong: '中国香港',
        Brazil: ' 巴西',
        Mexico: ' 墨西哥',
        Peru: ' 秘鲁',
        India: ' 印度',
        Philippines: ' 菲律宾',

        title5: '付款流程',
        subtitle51: '收集用户账户信息',
        subtitle52: '提交付款请求',
        subtitle53: '风控校验',
        subtitle54: '转账完成',
    },
    showcontent: 'Unionwallex深入调研各国支付习惯，涵盖10+国家和地区、10+本地语言、100+支付方式，助您轻松打开全球市场',
    numcontent1: '国家和地区',
    numcontent2: '本地语言',
    numcontent3: '支付方式',
    learnmore: '了解详情',

    merchantAccountManagePlatform: {
        title1: '商户账户管理平台\n' +
            '',
        content1: '贴心提供订单查询、数据分析、退款、结算等多项账户功能，减少您的运营成本。',

        title2: '多维的数据，助您有效提高收益\n',
        content2: '您可通过订单查询、数据导出、数据概览等功能，分析当前的支付趋势和用户行为，及时调整销售策略，提高收益。\n' +
            '\n',

        title3: '贴心的服务，助您快速解决客诉问题\n',
        cardtitle1: '自助处理客诉问题\n',
        cardcontent1: '支持30+国家的时区、多种订单查询条件，可以有效定位订单，有利于快速解决用户需求。',
        cardtitle2: '1V1高级账户服务',
        cardcontent2: 'Unionwallex免费提供1V1的高级账户服务，商务、产品、技术多团队贴心服务。\n' +
            '\n',

        title4: '灵活的策略，助您解决资金周转难题\n',
        cardtitle41: '自助对账\n',
        cardcontent41: '您可通过平台导出和sftp下载两种方式获取报表数据，完成对账。\n' +
            '\n',

        cardtitle42: '资金管理\n',
        cardcontent42: '您可随时查看当前账户资金，灵活调配资金，解决资金周转难题。\n' +
            '\n',
        cardtitle43: '自助结算\n',
        cardcontent43: '您可按需自助将待结算金额提现至账户。',

        title5: '严谨的管理，助您按需划分业务权限\n',
        cardtitle51: '审批流程\n',
        cardcontent51: '您可根据公司业务流程，自定义付款、退款内部审批流程。\n' +
            '\n',

        cardtitle52: "子账号功能\n",
        cardcontent52: '您可根据员工职能，设置不同的操作权限，保证数据安全，信息按需披露。\n' +
            '\n',

    },

    multiScenarioIntegration: {
        title1: '多场景接入\n' +
            '',
        content1: '良好适配手机、PC、平板多终端，满足您的多种支付场景。\n' +
            '\n',

        title2: 'Unionwallex满足您多种支付场景\n',
        content2: '以下场景均适配手机、PC、平板等设备\n' +
            '\n',


        cardtitle1: '应用内支付\n',
        cardcontent1: '用户可直接在您的应用中完成支付，减少页面跳转，提升用户体验。',
        cardtitle2: '网页端支付',
        cardcontent2: '用户可通过浏览器完成支付，完美适配移动端和PC端，适用性更广泛。' +
            '\n',
        cardtitle3: '订阅支付',
        cardcontent3: '用户一次授权，即可定期扣款，增加您的持续性收益。' +
            '\n',

        title3: '为您提供主流的对接方式\n',
        cardtitle31: 'API对接\n',
        cardcontent31: '1.适用于移动端（Android & iOS）和网页端商户\n',
        cardcontent311: '2.应用范围更广，对接更自由\n',
        cardtitle32: 'SDK对接\n',
        cardcontent32: '1.适用于具有app的移动端（Android）商户\n',
        cardcontent321: '2.对接简单快速，包体小，用户体验流程好'
    },

    about: {
        title1: '关于',
        content1: 'Unionwallex致力于提供专业的全球化在线支付解决方案。基于多年深耕新兴市场的经验，为商户提供更安全、便捷的一站式支付体验。 多年来，Unionwallex在中国香港、巴西、阿联酋、墨西哥、秘鲁、印度、泰国、菲律宾、等新兴市场地区，均已覆盖当地主流支付方式，并设立本地办公室，洞察本地财税法政策，为企业出海合规保驾护航。',

        emailDesc:"通过邮件联系我们，详细解答，高效沟通!",
        phoneDesc:"随时致电联系，一对一专业解答，专业解答一步到位！",
        telegramDesc:"通过Telegram联系我们，快速响应，随时沟通！",
        telegramBtn:"联系",
        cardtitle: '巴西公司执照',
        linkbtn: '点击查看执照',

        title2: '公司资质',
        content2: 'Unionwallex 持有多个重点市场的政府监管机构颁发的牌照，我们始终遵循在合规、合法的监管执行下保障客户资金安全。',

        title3: '全球本地公司',
        content3: '  目前已经在中国香港、巴西、阿联酋、墨西哥、秘鲁、印度、泰国、菲律宾等地设立公司。为您提供更加本地化的专业服务',
        hongkongCompanayLisense: '香港公司执照',
        uaeCompanyLicense: '阿联酋公司执照',
        thailandCompanyLicense: '泰国公司执照',
        nigeriaCompanyLicense: '尼日利亚公司执照',
    },

    contactobj: {
        contactintro: '联系我们获取更多支付资讯',
        title: '欢迎留言',
        target: '我们会尽快联系您',
        tab1: '商户合作',
        tab2: '用户反馈',
        applicationanme: '应用名称',
        buytime: '购买时间',
        userid: '用户ID',
        orderid: ' 订单号',
        paytype: '支付方式',
        currencyandamount: '购买币种',
        currencyandamount2: '购买金额',
        paymentscreenshot: '支付截图',
        commentplaceholder: '请填写您的问题，我们会尽快联系您',
        upload: '点击上传',
        uploadlimit: '请上传小于20M的单个文件',
        uploadmessage: '请提供支付凭证、扣款凭证等信息，便于我们快速定位您的问题。',
        selectdate: '选择日期'

    },
    message: {
        name: '姓名',
        email: '邮箱',
        phone: '电话',
        companyname: '公司名称',
        link: '公司官网/产品链接',
        comment: '留言',
        commentplaceholder: '我们需要了解更多您的业务信息，以便更好合作。',
        agreemessage: '您同意我们按照',
        privacy: 'Unionwallex 隐私政策'
    },
    userfeedback: 'User Feedback',
    sendmessage: '发送',


    // 导航
    nav: {
        solutions: '解决方案',
        resources: '资源中心',
        about: '关于我们',
        help: '帮助中心'
    },
    banner: {
        title: "无论你在哪里，服务就在身边！",
        title2: "打造全球地理一体的跨境支付平台！",
        desc: "UnionWallex致力于为电子商务用户提供便捷、专业的跨境支付服务，打造基于海外支付服务场景的综合支付服务体系，帮助中国企业在海外生产经营的全产业链覆盖。",
        more: "了解更多"
    },
    pic_desc1: "快速处理",
    pic_desc2: "一站式服务",
    pic_desc3: "7x24小时 客户支持",

    // 按钮
    button: {
        login: '登录',
        register: '注册'
    },

    // 语言选择
    language: {
        selector: 'CN-简体中文'
    },

    // 首页内容
    homepage: {
        title: '高效接入全球本地支付网络',
        description: 'UnionWallex的专属本地支付网络为企业提供比传统银行更快捷，成本更优，更透明的解决方案。',

        // 特色服务
        services: {
            item1: '无缝覆盖全球市场，快速触达多个国家与地区的消费者，显著提升转化率，打破跨境支付壁垒，助力业务全球化扩张。',
            item2: '智能优化支付成功率，实时风控引擎结合当地合规要求，降低交易失败率的同时保障资金安全，缩短回款周期。',
            item3: '一站式聚合管理与结算，全流程自动化处理，大幅降低运营成本，让跨境财务管理更高效透明。'
        },

        // 数据统计
        stats: {
            countriesBankAccounts: {
                value: '60+',
                unit: '',
                description: '个国家/地区开设本地银行账号'
            },
            totalTransactions: {
                value: '1000亿',
                description: '每年处理的全球交易总额'
            },
            localPayments: {
                value: '120+',
                unit: '',
                description: '个国家/地区开设本地付款'
            },
            acquiringCountries: {
                value: '180+',
                unit: '',
                description: '个国家/地区收单'
            }
        }
    },

    crossBorder: {
        title: "多方位跨境增值服务",
        desc: "产品服务覆盖全流程，让您的生意节节攀升。",
        services: {
            service1: {
                title: "全球收款，免费接入",
                content: "支持电商、应用、游戏、短剧、视频直播、数字商品等行业，通过网关支付、银行转账、电子钱包等进行收款，涵盖多个国家和地区、多个本地语言，助您轻松打开全球市场。"
            },
            service2: {
                title: "跨境付款，快速到账",
                content: "通过本地银行代付、电子钱包代付本地货币帮助客户实现本地员工、创作者、工会、MCN支付薪酬和分红。"
            }
        },
        security: {
            title: "操作安全合规",
            items: {
                fundSecurity: {
                    title: "资金安全",
                    content: "我们与全球顶尖金融机构合作，妥善管理您的资金，并严格遵循本地法规，确保您资金的流动性和安全性"
                },
                encryption: {
                    title: "机密技术",
                    content: "采用SSL加密、数据加密存储等技术，确保客户在支付过程中的信息安全，防止数据泄露和黑客攻击"
                },
                riskMonitor: {
                    title: "风险监控与预警",
                    content: "能够实时监测支付交易中的异常行为和风险因素，并及时发出预警，采取相应的措施进行防范和处理。"
                },
                compliance: {
                    title: "监管合规",
                    content: "UnionWallex严格遵守我们运营所在的全球众多市场的法规和行业标准。"
                },
                standards: {
                    title: "严格标准",
                    content: "UnionWallex严格遵守高水平的国际安全标准，并满足本地监管要求。"
                }
            }
        },
        efficiency: {
            title: "使用高效便捷",
            content: "提供一站式的跨境支付解决方案，客户无需与多个支付机构打交道，即可完成收款、付款、账户管理等一系列操作，简化业务流程，提高工作效率。",
            content1: "采用先进的技术架构和高效的支付处理系统，能够在短时间内完成跨境支付交易，大大缩短交易周期，提高资金周转效率。",
            content2: "提供全天候的在线客服服务，随时解答客户在使用平台过程中遇到的问题，确保客户的支付体验顺畅无阻。"
        },
        customization: {
            title: "提供定制化服务",
            solutions: {
                enterprise: "企业定制解决方案",
                enterprise_desc: "提供换汇、结算全链路跨境支付服务，无缝对接全球本地支付方式，智能优化汇率与合规流程，助力业务高效出海。",
                personal: "个性化服务支持",
                personal_desc: "专属跨境支付管家服务，1对1定制全球收付方案，覆盖多币种结算、本地合规与风控，提供全周期技术护航。",
                flexible: "灵活的支付方案",
                flexible_desc: "智能适配全球100+本地支付方式，支持多币种、多场景灵活结算，一键满足企业跨境收款与付款的个性化需求。"
            }
        }
    },

    faq: {
        title: "常见问题",
        questions:
            {
                title1: "为什么在同一天的交易中换汇汇率有所不同？",
                content1: "致力于为您提供最优质的汇率服务，为了实现这一点，我们将直接利用从支付供应商（如卡组织或本地支付渠道）收到的结算汇率，把您收到的不同币种的付款转换为您的默认结算币种。因此，您可能会发现同一天的不同交易使用的汇率有所不同，出现这种情况是因为不同的支付供应商使用各自的汇率，并且每个支付供应商的日常汇率更新截止时间可能与您的结算周期不同。",
                title2: "国际转账需要交税吗?",
                content2: "BRL会根据实时汇率换算成USD，从您的钱包中扣除。示例2：您在付款页面的“您汇出”字段输入1,000 USD，并选择BRL作为收款方收到的币种。由于巴西的金融操作税税率为0.38%，因此税款金额为3.8 USD（1,000 * 0.38%）。"
            }
    },
    compliance: {
        title: "安全合规",
        sections:
            {
                title1: "监管合规",
                content1: "为确保客户资金安全，自成立之初，UnionWallex便以积极的态度拥抱全球行业监管。我们建立了国际高标准的合规团队，严格遵循国际反洗钱公约以及监管机构的相关法律法规要求，以严格的行动践行责任。",
                title2: "金融合规",
                content2: "UnionWallex聘请国际会计师事务所高素质专业团队，对公司内部运营进⾏严格审核，确保自身合规。同时，建立成熟完善的反洗钱及反恐融资合规体系，对客户进⾏合规身份认证，确保客户资金和金融交易安全。",
                title3: "程序合规",
                content3: "UnionWallex的业务方案经过合作商业银行从海外到中国的多重合规检验。UnionWallex客户境外资金存放于国际一级清算银行的备付金账户，受各国金融监管部门和银行的双重保护；境内资金100%由持有第三方支付牌照的支付机构及境内银行处理。所有资金操作严格按照客户的指令进行。"
            }
    },
    privacy: {
        title: "隐私保护",
        content: "UnionWallex拥有一支金融和IT精英组成的技术和风险团队，有足够的信心和能力保障用户隐私。此外，UnionWallex以行业高标准建立完善的安全交易系统，通过权威第三方机构的独立测试和评估，严格保障用户信息及资金安全。未经您的授权，UnionWallex绝不会将您的信息透露给第三方。"
    },

    footer: {
        account_desc: "联系我们获取免费账户",
        connect_desc: "联系我们",
        products: "产品",
        products_global_acquiring: "全球收单",
        products_global_payments: "全球付款",
        products_global_getPay: "全球收款",
        products_risk_control_management: "风控管理",
        products_foreign_exchange_management: "外汇管理",
        products_fund_management: "资金管理",
        solutions: "解决方案",
        solutions_acquiring: "全球跨境收单",
        solutions_payments: "全球跨境付款",
        solutions_platform: "商户账户管理平台",
        solutions_access: "多场景接入",
        aboutUs: "关于我们",
        aboutUs_company: "公司介绍",
        aboutUs_news: "新闻动态",
        aboutUs_terms: "使用条款",
        aboutUs_join: "联系我们",
        resources: "资源中心",
        resources_deposit: "收单文档",
        resources_withdraw: "付款文档",
        resources_subscription: "订阅文档",
        copyright: "版权所有"
    },


    crossBorderAcquiring: {
        overview: {
            main_title: "跨境支付收单文档",
            title:"1 概述",
            purpose: {
                title: "1.1 文档目的",
                content: "本文档旨在为商户或合作伙伴提供跨境支付收单的技术集成指南、业务流程说明及合规要求，确保跨境支付的高效、安全和合规。"
            },
            scope: {
                title: "1.2 适用范围",
                content: "适用于所有通过平台进行跨境支付的商户、支付服务提供商及相关合作伙伴。"
            }
        },
        businessProcess: {
            title: "2. 业务流程",
            paymentProcess: {
                title: "2.1 支付流程",
                steps: {
                    step1: "用户下单并选择支付方式（如信用卡、电子钱包、银行转账等）。",
                    step2: "支付请求发送至支付网关。",
                    step3: "支付网关进行风控检查、汇率转换（如适用）并路由至相应的支付渠道。",
                    step4: "支付结果返回至商户系统。"
                }
            },
            settlementProcess: {
                title: "2.2 结算流程",
                steps: {
                    step1: "交易完成后，资金结算至商户的指定账户（可能涉及多币种结算）。",
                    step2: "结算周期根据合同约定（如T+1、T+3等）。",
                    step3: "结算报表生成并提供给商户。"
                }
            }
        },
        technicalIntegration: {
            title: "3. 技术集成",
            api: {
                title: "3.1 API接口",
                paymentRequest: "支付请求API：用于发起支付请求，包含订单信息、支付金额、币种等字段。",
                paymentNotification: "支付结果通知API：异步通知支付结果（成功/失败）。",
                query: "查询API：用于查询订单状态。"
            },
            dataFormat: {
                title: "3.2 数据格式",
                content: "请求和响应数据通常采用JSON或XML格式。"
            },
            security: {
                title: "3.3 加密与安全",
                https: "使用HTTPS协议确保数据传输安全。",
                signature: "支持签名验证（如SHA256、RSA等）防止数据篡改。"
            }
        },
        compliance: {
            title: "4. 合规要求",
            aml: {
                title: "4.1 反洗钱（AML）",
                content: "商户需提供真实有效的身份信息（KYC）。交易监控和报告可疑活动。"
            },
            dataProtection: {
                title: "4.2 数据保护",
                content: "遵守GDPR、PCI DSS等数据保护法规。不得存储用户的敏感支付信息（如信用卡CVV）。"
            },
            forex: {
                title: "4.3 外汇管理",
                content: "遵守各国外汇管理政策，确保资金合法跨境流动。"
            }
        },
        riskManagement: {
            title: "5. 风险管理",
            measures: {
                title: "5.1 风控措施",
                monitoring: "实时交易监控，识别异常交易（如大额交易、高频交易）。",
                secure3D: "支持3D Secure验证以提高信用卡支付安全性。"
            },
            chargeback: {
                title: "5.2 拒付与争议处理",
                process: "提供拒付（Chargeback）处理流程。",
                evidence: "商户需保留交易凭证以备争议处理。"
            }
        },
        feesAndSettlement: {
            title: "6. 费用与结算",
            feeStructure: {
                title: "6.1 费用结构",
                transactionFee: "交易手续费：按交易金额的百分比或固定费用收取。",
                exchangeRateMargin: "汇率差价：如涉及货币转换，可能收取汇率差价。",
                settlementFee: "结算费用：跨境结算可能产生的银行手续费。"
            },
            settlementCycle: {
                title: "6.2 结算周期",
                content: "根据合同约定，通常为T+1至T+7。支持多币种结算。"
            }
        },
        supportAndMaintenance: {
            title: "7. 支持与维护",
            technicalSupport: {
                title: "7.1 技术支持",
                content: "提供7x24小时技术支持服务。提供API文档、SDK及集成示例。"
            },
            updates: {
                title: "7.2 更新与维护",
                content: "定期更新API版本，确保系统兼容性。通知商户系统升级或维护计划。"
            }
        }
    },


    crossBorderPayment: {
        overview: {
            main_title: "跨境支付付款文档",
            title:"1 概述",
            purpose: {
                title: "1.1 文档目的",
                content: "本文档旨在为用户或商户提供跨境支付付款的操作指南，包括付款流程、技术集成、费用说明及合规要求，确保付款过程高效、安全、合规。"
            },
            scope: {
                title: "1.2 适用范围",
                content: "适用于所有通过平台进行跨境支付的用户、商户及合作伙伴。"
            }
        },
        paymentProcess: {
            title: "2. 付款流程",
            userPaymentProcess: {
                title: "2.1 用户付款流程",
                step1: "用户选择商品或服务并进入支付页面。",
                step2: "选择支付方式（如信用卡、电子钱包、银行转账等）。",
                step3: "输入支付信息（如卡号、有效期、CVV等）。",
                step4: "确认支付金额及币种（如涉及货币转换）。",
                step5: "支付请求发送至支付网关，完成支付。"
            },
            paymentResultNotification: {
                title: "2.2 支付结果通知",
                step1: "支付成功后，用户收到支付成功通知。",
                step2: "商户系统通过异步通知（Webhook）接收支付结果。"
            }
        },
        technicalIntegration: {
            title: "3. 技术集成",
            api: {
                title: "3.1 API接口",
                paymentRequest: "付款请求API：用于发起付款请求，包含付款金额、币种、收款方信息等字段。",
                paymentNotification: "付款结果通知API：异步通知付款结果（成功/失败）。",
                query: "查询API：用于查询付款状态。"
            },
            dataFormat: {
                title: "3.2 数据格式",
                content: "请求和响应数据通常采用JSON或XML格式。"
            },
            security: {
                title: "3.3 加密与安全",
                https: "使用HTTPS协议确保数据传输安全。",
                signature: "支持签名验证（如SHA256、RSA等）防止数据篡改。"
            }
        },
        compliance: {
            title: "4. 合规要求",
            aml: {
                title: "4.1 反洗钱（AML）",
                content: "用户需提供真实有效的身份信息（KYC）。交易监控和报告可疑活动。"
            },
            dataProtection: {
                title: "4.2 数据保护",
                content: "遵守GDPR、PCI DSS等数据保护法规。不得存储用户的敏感支付信息（如信用卡CVV）。"
            },
            forex: {
                title: "4.3 外汇管理",
                content: "遵守各国外汇管理政策，确保资金合法跨境流动。"
            }
        },
        feesAndExchangeRates: {
            title: "5. 费用与汇率",
            feeStructure: {
                title: "5.1 费用结构",
                transactionFee: "交易手续费：按付款金额的百分比或固定费用收取。",
                exchangeRateMargin: "汇率差价：如涉及货币转换，可能收取汇率差价。",
                bankFee: "银行手续费：跨境付款可能产生的银行手续费。"
            },
            exchangeRate: {
                title: "5.2 汇率说明",
                realTime: "实时汇率：根据市场汇率实时计算。",
                locked: "锁定汇率：部分服务支持锁定汇率，确保付款金额固定。"
            }
        },
        riskManagement: {
            title: "6. 风险管理",
            measures: {
                title: "6.1 风控措施",
                monitoring: "实时交易监控，识别异常付款（如大额付款、高频付款）。",
                secure3D: "支持3D Secure验证以提高信用卡付款安全性。"
            },
            refunds: {
                title: "6.2 退款与争议处理",
                process: "提供退款流程，退款金额按原路径返回。",
                dispute: "用户可发起争议，商户需提供交易凭证以解决争议。"
            }
        },
        supportAndMaintenance: {
            title: "7. 支持与维护",
            technicalSupport: {
                title: "7.1 技术支持",
                content: "提供7x24小时技术支持服务。提供API文档、SDK及集成示例。"
            },
            updates: {
                title: "7.2 更新与维护",
                content: "定期更新API版本，确保系统兼容性。通知用户或商户系统升级或维护计划。"
            }
        }
    },

    crossBorderPaymentSub: {
        overview: {
            main_title: "跨境支付订阅文档",
            title:"1 概述",
            purpose: {
                title: "1.1 文档目的",
                content: "本文档旨在为商户或用户提供跨境支付订阅服务的操作指南，包括订阅创建、付款流程、技术集成、合规要求及费用说明，确保订阅模式的高效、安全和合规。"
            },
            scope: {
                title: "1.2 适用范围",
                content: "适用于所有通过平台提供或使用跨境订阅服务的商户、用户及合作伙伴。"
            }
        },
        subscriptionModel: {
            title: "2. 订阅模式说明",
            types: {
                title: "2.1 订阅类型",
                fixedCycle: "固定周期订阅：按固定周期（如每月、每年）自动扣款。",
                usageBased: "按用量订阅：根据实际使用量定期结算（如云服务、API调用次数）。"
            },
            lifecycle: {
                title: "2.2 订阅生命周期",
                create: "创建订阅：用户选择订阅计划并完成首次付款。",
                renew: "续订：在订阅周期结束时自动扣款续订。",
                cancel: "取消订阅：用户可随时取消订阅，取消后不再扣款。",
                expire: "订阅到期：订阅取消或付款失败后，订阅状态变更为“到期”。"
            }
        },
        paymentProcess: {
            title: "3. 付款流程",
            firstPayment: {
                title: "3.1 首次付款",
                content: "用户选择订阅计划并完成首次付款。支付方式包括信用卡、电子钱包、银行转账等。"
            },
            autoRenewal: {
                title: "3.2 自动续订",
                content: "在订阅周期结束时，系统自动发起扣款请求。扣款成功后，订阅周期延长。"
            },
            paymentFailure: {
                title: "3.3 付款失败处理",
                content: "扣款失败后，系统会尝试重新扣款（如3次重试）。若重试仍失败，订阅状态变更为“到期”。"
            }
        },
        technicalIntegration: {
            title: "4. 技术集成",
            api: {
                title: "4.1 API接口",
                create: "创建订阅API：用于创建订阅计划，包含订阅周期、金额、币种等字段。",
                notify: "扣款通知API：异步通知每次扣款结果（成功/失败）。",
                cancel: "取消订阅API：用于取消订阅。",
                query: "查询订阅API：用于查询订阅状态及历史记录。"
            },
            dataFormat: {
                title: "4.2 数据格式",
                content: "请求和响应数据通常采用JSON或XML格式。"
            },
            security: {
                title: "4.3 加密与安全",
                https: "使用HTTPS协议确保数据传输安全。",
                signature: "支持签名验证（如SHA256、RSA等）防止数据篡改。"
            }
        },
        compliance: {
            title: "5. 合规要求",
            aml: {
                title: "5.1 反洗钱（AML）",
                content: "用户需提供真实有效的身份信息（KYC）。定期监控订阅交易，报告可疑活动。"
            },
            dataProtection: {
                title: "5.2 数据保护",
                content: "遵守GDPR、PCI DSS等数据保护法规。不得存储用户的敏感支付信息（如信用卡CVV）。"
            },
            forex: {
                title: "5.3 外汇管理",
                content: "遵守各国外汇管理政策，确保资金合法跨境流动。"
            }
        },
        feesAndRates: {
            title: "6. 费用与汇率",
            feeStructure: {
                title: "6.1 费用结构",
                transactionFee: "交易手续费：按每次扣款金额的百分比或固定费用收取。",
                exchangeRateMargin: "汇率差价：如涉及货币转换，可能收取汇率差价。",
                bankFee: "银行手续费：跨境付款可能产生的银行手续费。"
            },
            exchangeRate: {
                title: "6.2 汇率说明",
                realTime: "实时汇率：根据市场汇率实时计算。",
                locked: "锁定汇率：部分服务支持锁定汇率，确保扣款金额固定。"
            }
        },
        riskManagement: {
            title: "7. 风险管理",
            measures: {
                title: "7.1 风控措施",
                monitoring: "实时监控订阅交易，识别异常扣款（如大额扣款、高频扣款）。",
                secure3D: "支持3D Secure验证以提高信用卡付款安全性。"
            },
            refunds: {
                title: "7.2 退款与争议处理",
                process: "提供退款流程，退款金额按原路径返回。",
                dispute: "用户可发起争议，商户需提供交易凭证以解决争议。"
            }
        },
        supportAndMaintenance: {
            title: "8. 支持与维护",
            technicalSupport: {
                title: "8.1 技术支持",
                content: "提供7x24小时技术支持服务。提供API文档、SDK及集成示例。"
            },
            updates: {
                title: "8.2 更新与维护",
                content: "定期更新API版本，确保系统兼容性。通知用户或商户系统升级或维护计划。"
            }
        }
    },

    login: {
        title: '登录',
        email: '邮箱',
        password: '密码',
        submit: '登录',
        reset: '重置',
        emailRequired: '请输入邮箱',
        emailInvalid: '请输入正确的邮箱格式',
        passwordRequired: '请输入密码',
        success: '登录成功',
    },
    register: {
        title: '注册',
        email: '邮箱',
        password: '密码',
        confirmPassword: '确认密码',
        submit: '注册',
        reset: '重置',
        emailRequired: '请输入邮箱',
        emailInvalid: '请输入正确的邮箱格式',
        passwordRequired: '请输入密码',
        confirmPasswordRequired: '请再次输入密码',
        passwordMismatch: '两次输入的密码不一致',
        success: '注册成功',
    },

    policyTitle: '隐私策略',
    introduction: `Unionwallex 由 Unionwallex Limited（“Unionwallex”、“我们”或“我们的”）运营，充当支付聚合商，为我们的客户（“商家”）提供支付处理（“Unionwallex服务”）。在此付款处理期间，Unionwallex将需要个人信息来处理特定交易。本Unionwallex隐私政策描述了我们如何收集、使用、存储和披露个人信息。Unionwallex在提供服务时可能会处理以下类别的`,

    infoCollectionTitle: '第1节：我们收集的信息以及我们如何使用这些信息',
    infoCollectionItem1: '当您向使用Unionwallex服务的商家付款或接收付款时；',
    infoCollectionItem2: '当您查询我们的Unionwallex服务或以其他方式在我们的网站上互动时；',
    infoCollectionItem3: '当您通过电话、电子邮件和其他电子通信与我们互动时；',
    infoCollectionItem4: '当您与我们或我们正在合作的第三方参加活动或注册接收我们的出版物时；',
    infoCollectionItem5: '当我们将您加入为商家并就我们的服务进行互动时；',
    infoCollectionItem6: '当您向我们提供服务或寻求提供此类服务时我们还可能根据需要处理来自第三方来源的个人信息，以提供Unionwallex服务。我们可能会根据您的情况从您的组织、公共来源或第三方获取这些信息。例如，我们可能会从以下位置获取有关您的某些个人信息：',

    infoSharingTitle: '第2节：我们共享的信息',
    infoSharingItem1: '商家。如果我们在向该商家提供Unionwallex服务的过程中收集了您的个人信息，并在法律允许的情况下为提供Unionwallex服务而向其他人提供。例如，当您与该商家进行购买或交易时，我们会将有关您的某些个人信息提供给您从其购买或与之交易的商家; ',
    infoSharingItem2: '获得许可的支付服务提供商。我们可能会交换有关您的某些个人信息以提供 Unionwallex服务，例如您与获得许可的支付服务提供商或银行的交易信息，以提供 Unionwallex服务;',
    infoSharingItem3: '为AML/KYC检查、降低信用风险以及其他欺诈和犯罪预防目的提供服务的第三方，或类似服务，包括与之共享此类个人信息的金融机构、信用调查机构和监管机构;',
    infoSharingItem4: '法院、执法机构、监管机构、政府官员或其他主管当局，在建立、行使或捍卫法律或衡平法索赔的合理必要情况下，包括为了保护您和他人的合法权益。此类披露对于我们遵守 FATF的要求和当地AML/CFT要求可能是必要的。我们可能会向主管当局提供您的客户ID、联系信息和任何其他交易信息;',
    infoSharingItem5: '我们聘请的服务提供商，仅代表我们并仅根据我们的指示出于上述任何目的处理个人信息，例如许可支付服务提供商、云存储提供商;',
    infoSharingItem6: '我们可能转让或更新我们的任何权利和义务的任何业务或资产的潜在卖家或买家;在这种情况下，我们可能会向此类业务或资产的潜在卖家或买家披露您的个人信息。',
    infoSharingItem7: '关联公司：我们可能会与关联公司共享您的个人信息，以便为您提供支付服务。您直接提供给第三方商家、网站或应用程序的任何信息均不在本Unionwallex隐私政策的涵盖范围内。对于您选择直接与之共享个人信息的商家或其他第三方的隐私或安全做法，我们概不负责。我们鼓励您查看您选择直接与之共享个人信息的任何第三方的隐私政策。我们收集的个人信息可能会出于本隐私政策中规定的目的，传输到您使用Unionwallex服务的国家/地区并存储在这些国家/地区之外。例如，我们将所有数据（包括个人信息）存储在新加坡的 AWS 中。您个人信息的任何国际传输都将根据适用法律和法规的适当保护措施进行。如果您想进一步询问所使用的这些保护措施，请使用本隐私政策第8节中列出的详细信息与我们联系。我们可能会将您的个人信息传输到您使用Unionwallex服务的国家/地区之外，我们将根据适用法律的要求保护个人信息。',

    dataRetentionTitle: '第3节：数据保留期限',
    dataRetentionContent: '您的个人信息将仅在收集信息的目的所需的时间内保留，除非为履行我们的法律义务（例如，与 KYC/AML 要求有关）或建立、行使或捍卫潜在的法律索赔或追求我们的合法利益所必需。',

    userRightsTitle: '第4节：用户权利',
    userRightsDesc: '您的权利将取决于适用于您和我们的法律，但您可能拥有：',
    userRightsItem1: '访问您的个人信息的权利；',
    userRightsItem2: '更正或删除我们持有的您的个人信息；',
    userRightsItem3: '限制我们对该信息的处理；',
    userRightsItem4: '反对我们处理个人信息；',
    userRightsItem5: '将您的个人信息传输给您或其他组织,向相关数据保护机构提出投诉。',
    userRightsItemDesc: '如果您已同意我们进行处理，您可以撤回同意。请注意，即使您选择撤回同意，我们也可能能够在法律要求或允许的范围内继续处理您的个人信息，特别是与行使和捍卫我们的合法权利或履行我们的法律和监管义务有关的信息。要撤回您的同意或行使上述任何权利（如果适用），您应该使用下文第8节中列出的我们的联系方式。我们必须确保我们持有的您的个人信息准确且最新（如适用）。因此，如果您的信息有任何变更，请通过电子邮件告知我们。',

    // 第5节：安全
    securityTitle: '第5节：安全',
    securityContent: '我们非常重视保护您信息的机密性。我们采用管理、物理和电子措施，旨在保护您的信息免受未经授权的访问和使用。请注意，我们为保护您的信息而采取的任何安全措施都不能保证不会防止未经授权的访问或使用您的信息。',
    sensitiveInfoContent: '我们要求您不要通过 Unionwallex向我们发送或披露任何敏感的个人信息（例如，与您的电子钱包密码、信用卡或借记卡密码、种族或民族血统、政治观点、宗教或其他信仰、健康、性取向、犯罪背景或过去组织的成员身份，包括工会会员资格相关的信息），除非我们需要此类信息进行法律合规性检查，例如KYC/AML。',

    // 第6节：联系我们
    contactTitle: '第6节：联系我们',
    contactContent: "如果您对本Unionwallex隐私政策或我们的隐私实践有任何疑问、投诉或意见，或报告任何违反Unionwallex隐私政策的行为，请通过以下方式与我们联系：'service&#64;Unionwallex.com'。",

    // 第7节：变更
    changeTitle: '第7节：本隐私政策的变更',
    changeContent: '我们可能会不时修订本Unionwallex隐私政策，以反映我们处理您个人信息的方式的任何变化或法律要求的变化。最新版本的政策将约束我们对您的信息的使用。请经常回来查看任何更新或更改。本隐私政策的最后更新日期为本页顶部提供的日期。',

    // 第8节：补充条款
    supplementTitle: '第8节：补充条款',
    supplementIntro: '如果您是下面指定的相关司法管辖区的用户，则以下附加或修订条款将适用于您：',
    brazilContent: `
    <strong>1、巴西</strong><br>
    第13,709/2018号法律（巴西通用数据保护法，又名“LGPD”）为位于巴西的个人提供了额外的权利和法规。除了本隐私政策第1、5、7和10节中规定的信息外，如果您位于巴西，以下附加信息适用于您：<br>
    <u>未成年人的个人信息</u>：我们不会故意收集18岁以下儿童和青少年的个人信息或与之相关的个人信息。如果您未满18岁，请不要尝试使用Unionwallex服务或向我们发送有关您自己的任何个人信息。如果我们得知我们收集了18岁以下的儿童或青少年的个人信息，我们将尽快删除该信息。<br> 
    <u>数据主体的请求</u>：根据 LGPD 第18条，您作为数据主体享有以下权利：<br>
    • 确认存在处理活动<br>
    • 访问您的个人信息<br>
    • 更正不完整、不准确或过时的个人信息<br>
    • 匿名化、阻止或删除不必要或过多的个人信息<br>
    • 您个人信息的可移植性<br>
    • 删除经您同意处理的您的个人信息<br>
    • 我们与之共享您的个人信息的公共和私人实体的信息<br>
    • 关于不提供同意的可能性和拒绝的后果的信息<br>
    • 撤销同意和向国家数据保护局（“ANPD”）提起的针对我们的申请
  `,
    indonesiaContent: `<br>
    <strong>2、印度尼西亚</strong><br>
    如果服务在印度尼西亚共和国境内使用或访问，则以下补充条款应适用并优先于隐私政策中的任何冲突条款：<br>
    • 第三方同意：如果您提供第三方个人和/或各方的任何个人数据或信息，则您声明并保证您已获得必要的同意<br>
    • 数据共享：未经您的同意，我们不会出于提供此处指定的Unionwallex服务以外的任何目的与第三方共享您的信息<br>
    • 管辖语言：本隐私政策以英文和印尼语版本制定。如果英文和印尼语版本之间存在任何差异，应以英文版本为准<br>
    • 父母或监护人同意：如果您未满21岁，您特此声明您已获得父母或法定监护人的同意使用Unionwallex服务<br>
    • 弃权：为了终止和/或解散和/或撤销隐私政策，我们和您特此放弃《印度尼西亚民法典》第1266条规定的适用性
  `,
    philippinesContent: `<br>
    <strong>3、菲律宾</strong><br>
    如果在菲律宾境内使用或访问服务，则以下补充条款应适用并优先于隐私政策中的任何冲突条款：<br>
    <u>第1条补充</u>：（我们收集的信息以及我们如何使用这些信息），增加：如果您向我们提供了第三方个人的个人信息，您需要事先获得该个人的同意，并且您声明并保证您已经或已获得他们的同意，或以其他方式有权向我们提供他们的个人信息。向我们提供第三方个人的个人信息，即表示您还保证该个人被告知并同意本隐私政策的条款。<br>
    <u>第3条修订</u>：（我们共享的信息），将项目符号 3 和 5 组合如下：我们聘请的服务提供商仅代表我们并仅根据我们的指示出于上述任何目的处理个人信息，例如当地持牌支付服务提供商、云存储提供商以及为 AML/KYC 检查、信用风险降低和其他欺诈和犯罪预防目的提供服务的公司，以及提供类似服务的公司，包括与之共享此类个人数据的金融机构、信用调查机构和监管机构。<br>
    <u>第5条补充</u>：（您的权利）如果您已同意我们进行处理，您可以撤回同意。请注意，即使您选择撤回同意，我们也可能能够在法律要求或允许的范围内继续处理您的个人信息，特别是与行使和捍卫我们的合法权利或履行我们的法律和监管义务有关，或用于本隐私政策中规定的任何目的，其中处理您的个人信息不是基于同意。
  `,
    southkoreaContent: `<br>
    <strong>4、韩国</strong><br>
如果服务在韩国境内使用或访问，则以下补充条款应适用并优先于隐私政策中的任何冲突条款：在达到处理您的个人信息的目的后，您的个人信息将被传输到单独的数据库（如果您的信息以纸质形式保留，则移至单独的存储），并根据Unionwallex的内部规定和其他适用的法律法规保留一段时间，然后再销毁。您转移到单独数据库的个人信息不会用于其他目的，除非适用的法律法规要求。在销毁您的个人信息时，我们将采取合理且技术上可行的措施使个人信息无法恢复。例如，包含个人信息的电子文件将使用无法恢复的技术方法永久删除，任何其他记录、打印输出、文档或任何其他记录媒体将被粉碎或焚烧。
  `,




    // 通用文案
    common: {
        // 可能重复使用的单位符号
        plusSign: '+',
        example:'示例'
    }
};

export default zh;
